/**
 * 门户端-解决方案
 */

import request from "@/utils/request";
import { isFunction } from "@/utils/type";

/**
 * 分页查询
 */
export function getList(params) {
  let { cancelBack } = params,
    controller = new AbortController();
  delete params.cancelBack;
  let axios = request({
    url: "/api/v1/portal/store",
    method: "get",
    params,
    signal: controller.signal,
  });
  if (isFunction(cancelBack)) {
    // console.log("set cancelBack");
    cancelBack(controller);
  }
  return axios;
}

/**
 * 详情获取
 */
export function getDetails(params) {
  const { id } = params;
  return request({
    url: "/api/v1/portal/store/" + id,
    method: "get",
    params,
  });
}

export default {
  getList,
  getDetails,
};
